import { render, staticRenderFns } from "./SelecionarMarcaProdutosCombinados.vue?vue&type=template&id=ef305fd6"
import script from "./SelecionarMarcaProdutosCombinados.vue?vue&type=script&setup=true&lang=js"
export * from "./SelecionarMarcaProdutosCombinados.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports